import { render, staticRenderFns } from "./parkingArea.vue?vue&type=template&id=134152d2&scoped=true&"
import script from "./parkingArea.vue?vue&type=script&lang=js&"
export * from "./parkingArea.vue?vue&type=script&lang=js&"
import style0 from "./parkingArea.vue?vue&type=style&index=0&id=134152d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134152d2",
  null
  
)

export default component.exports